import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Checkbox } from "antd";

import "./styles.scss";
import { identity } from "../../utils/getIdentity";

const TypesFilter = ({ setType, checkedList, setCheckedList, indeterminate, setIndeterminate}) => {

  const defValue = "replenishment,withdrawal,Error,refund,multisend,InternalTransfer,ExternalCall,SystemFee";
  const { t } = useTranslation();

  const options = [
    { label: t('admin.replenishment'), value: "replenishment" },
    { label: t('admin.withdrawal'), value: "withdrawal" },
    { label: t('admin.refund'), value: "refund" },
    { label: t('text.multisend'), value: "multisend" },
    { label: t('admin.internal_transfer'), value: "InternalTransfer" },
    { label: t('admin.external_call'), value: "ExternalCall" },
    { label: t('admin.error'), value: "Error" },
    { label: t('transactionFilter.dropdown.systemFee'), value: "SystemFee" },
  ];

  const optValue = options.flatMap((opts) => opts.value);

  // const [checkDefault, setCheckDefault] = useState(true)

  const onChange = (list) => {
    // setIndeterminate(!!list.length && list.length < optValue.length);
    if (!!list.length && list.length === optValue.length) {
      setCheckedList([]);
      setIndeterminate(false);
    } else {
      setCheckedList(list);
      setIndeterminate(true);
    }
    const valueToString = list.toString();
    setType(valueToString);
    localStorage.setItem('type_tr', valueToString)

  };

  const onCheckAllChange = (e) => {
    console.log(e.target.checked);
    // setType(e.target.checked ? defValue : "");
    setType(defValue);
    localStorage.setItem('type_tr',defValue)
    if (!!checkedList.length && checkedList.length < optValue.length) {
      setIndeterminate(false);
      setCheckedList([]);
    }
  };

  return (
    <div className={`transaction-filters__types transaction-filters__types-${identity}`}>
      <div className={`transaction-filters__types-title transaction-filters__types-title-${identity}`}>
        <p>{t("transactionHistory.type")}</p>
      </div>
      <div className={`transaction-filters__types-box transaction-filters__types-box-${identity}`}>
        <Checkbox
          indeterminate={indeterminate}
          onChange={onCheckAllChange}
          checked={!indeterminate}
          //  defaultChecked={!indeterminate}
        >
          {t('admin.all')}
        </Checkbox>

        <Checkbox.Group options={options} value={checkedList} onChange={onChange} />
      </div>
    </div>
  );
};

export default TypesFilter;